import React, { useContext } from "react";
import { Grid } from "../../../grid";
import { Redirect } from "react-router";
import { useWrContext } from "../../../wr-context";
var DocumentEditorContext = /*#__PURE__*/ React.createContext({
    builder: null
});
export var DocumentEditorWrapper = function(param) {
    var builder = param.builder, children = param.children;
    var context = useWrContext();
    if (!context.state.cart.length) {
        return /*#__PURE__*/ React.createElement(Redirect, {
            to: context.getRoutePath("index")
        });
    }
    return /*#__PURE__*/ React.createElement(Grid, null, /*#__PURE__*/ React.createElement(DocumentEditorContext.Provider, {
        value: {
            builder: builder
        }
    }, children));
};
export var useProvidedBuilder = function() {
    var ref;
    var builder = (ref = useContext(DocumentEditorContext)) === null || ref === void 0 ? void 0 : ref.builder;
    if (!builder) throw new Error("useProvidedBuilder should be used inside a DocumentEditorWrapper");
    return builder;
};
